import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap'; // Assuming you're using react-bootstrap
import { guaranteeService } from '../../services/api';

const handlePriceConversion = (price) => {
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price);
}

function GuaranteePrice({ duration = 365 }) {
  const [price, setPrice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        setLoading(true);
        const priceData = await guaranteeService.getPrices(duration);
        setPrice(priceData);
        setError(null);
      } catch (err) {
        setError(err.message || 'Fehler beim Laden des Preises');
        console.error('Fehler beim Laden des Preises', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrice();
  }, [duration]); // Re-fetch when duration changes

  return (
    <Card.Body>
      <div className="mb-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5>Gesamtpreis:</h5>
          {loading ? (
            <h5>Wird geladen...</h5>
          ) : error ? (
            <h5 className="text-danger">Error loading price</h5>
          ) : (
            <h5 className="text-primary">{handlePriceConversion(price)}</h5>
          )}
        </div>
      </div>
    </Card.Body>
  );
}

export default GuaranteePrice;